module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/voltaique-bc5c3e8f1ed5215f5b537aa436d66c5a.png";